document.addEventListener('DOMContentLoaded', () => {
  const menus = [...document.querySelectorAll('.cl-mega-menu')];
  let closeTimer;

  const closeOtherMenus = (current) => {
    menus.forEach((menu) => {
      if (menu !== current) menu.removeAttribute('open');
    });
  };

  const disclosures = [...document.querySelectorAll('details[data-cl-disclosure]')];
  const closeDisclosure = (disclosure, restoreFocus = false) => {
    if (!disclosure?.open) return;
    disclosure.removeAttribute('open');
    if (restoreFocus) disclosure.querySelector(':scope > summary')?.focus();
  };

  disclosures.forEach((disclosure) => {
    const trigger = disclosure.querySelector(':scope > summary');
    trigger?.setAttribute('aria-expanded', String(disclosure.open));
    disclosure.addEventListener('toggle', () => {
      trigger?.setAttribute('aria-expanded', String(disclosure.open));
      if (!disclosure.open) return;
      disclosures.forEach((other) => {
        if (other !== disclosure) closeDisclosure(other);
      });
      closeOtherMenus(null);
    });
    disclosure.addEventListener('keyup', (event) => {
      if (event.key === 'Escape') event.stopPropagation();
    });
  });

  document.addEventListener('pointerdown', (event) => {
    disclosures.forEach((disclosure) => {
      if (disclosure.open && !disclosure.contains(event.target)) closeDisclosure(disclosure);
    });
  });

  document.addEventListener('focusin', (event) => {
    disclosures.forEach((disclosure) => {
      if (disclosure.open && !disclosure.contains(event.target)) closeDisclosure(disclosure);
    });
  });

  document.addEventListener('click', (event) => {
    const closeAction = event.target.closest?.('[data-cl-disclosure-close]');
    const disclosure = closeAction?.closest('details[data-cl-disclosure]');
    if (disclosure) closeDisclosure(disclosure, true);
  });

  document.addEventListener('change', (event) => {
    const select = event.target.closest?.('[data-cl-localization-select]');
    if (!select) return;
    const disclosure = select.closest('details[data-cl-disclosure]');
    closeDisclosure(disclosure);
    const form = select.form;
    if (form?.requestSubmit) form.requestSubmit();
    else form?.submit();
  });

  menus.forEach((menu) => {
    const trigger = menu.querySelector(':scope > summary');
    const open = () => {
      window.clearTimeout(closeTimer);
      closeOtherMenus(menu);
      menu.setAttribute('open', '');
      trigger?.setAttribute('aria-expanded', 'true');
    };
    const scheduleClose = () => {
      closeTimer = window.setTimeout(() => {
        if (!menu.matches(':hover') && !menu.contains(document.activeElement)) {
          menu.removeAttribute('open');
          trigger?.setAttribute('aria-expanded', 'false');
        }
      }, 260);
    };

    menu.addEventListener('pointerenter', (event) => {
      if (event.pointerType === 'mouse') open();
    });
    menu.addEventListener('pointerleave', (event) => {
      if (event.pointerType === 'mouse') scheduleClose();
    });
    menu.addEventListener('toggle', () => trigger?.setAttribute('aria-expanded', String(menu.open)));
    menu.addEventListener('focusout', scheduleClose);
    menu.querySelector('.cl-mega-menu__content')?.addEventListener('pointerenter', (event) => {
      if (event.pointerType === 'mouse') open();
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    if (event.target.closest?.('predictive-search[open]')) return;
    const activeDisclosure = [...disclosures]
      .reverse()
      .find((disclosure) => disclosure.open && disclosure.contains(document.activeElement));
    const openDisclosure = activeDisclosure || [...disclosures].reverse().find((disclosure) => disclosure.open);
    if (openDisclosure) {
      event.preventDefault();
      event.stopPropagation();
      closeDisclosure(openDisclosure, true);
      return;
    }
    const drawer = document.querySelector('header-drawer');
    const drawerDetails = drawer?.querySelector(':scope > details[open]');
    if (drawerDetails && typeof drawer.closeMenuDrawer === 'function') {
      drawer.closeMenuDrawer(event, drawerDetails.querySelector(':scope > summary'));
    }
    const openMenu = document.querySelector('.cl-mega-menu[open]');
    if (openMenu) {
      const trigger = openMenu.querySelector(':scope > summary');
      openMenu.removeAttribute('open');
      trigger?.setAttribute('aria-expanded', 'false');
      trigger?.focus();
    }
  });
});
